import { render, staticRenderFns } from "./web_config.vue?vue&type=template&id=8f783f6c&scoped=true&"
import script from "./web_config.vue?vue&type=script&lang=js&"
export * from "./web_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f783f6c",
  null
  
)

export default component.exports